module.exports = __webpack_public_path__ + "img/9788974839253.c1d02696.jpg";